import Vue from 'vue';
import { NavigationGuard, RawLocation } from 'vue-router';

export abstract class GuardClass {
  public static execute: NavigationGuard;
}

export type GuardResolveFunction = (to?: RawLocation | false | ((vm: Vue) => any) | void) => void;
